import React from 'react';
import { useSelector } from 'react-redux';

import RoleButton from 'components/RoleButton';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

import { AppState } from 'services/types';

import {
    makeSelectSprayEventIsSubmitted,
    makeSelectSprayEventIsCompleted
} from '../../selectors';

import { UNCOMPLETE_SPRAY_EVENT_MODAL } from '../../constants';

const UncompleteSprayEventButton = (): React.ReactElement | null => {
    const isCompleted = useSelector((state: AppState) =>
        makeSelectSprayEventIsCompleted()(state)
    );
    const isSubmitted = useSelector((state: AppState) =>
        makeSelectSprayEventIsSubmitted()(state)
    );

    if (!isCompleted || isSubmitted) {
        return null;
    }

    return (
        <RoleButton
            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
            params={{
                [UNCOMPLETE_SPRAY_EVENT_MODAL]: true
            }}
            buttonProps={{
                negative: true
            }}
            ignoreSeason
        >
            Uncomplete
        </RoleButton>
    );
};

export default UncompleteSprayEventButton;
